export const messages = {
    'downloadsSummary.total.title': 'Available',
    'downloadsSummary.total.text': (count: number | string) => `${count} ${count == 1 ? 'Resource' : 'Resources'}`,
    'downloadsSummary.title': 'All Resources',

    'downloadPage.noInfo': 'No information',
    'downloadPage.title': 'Resources',

    'downloadPage.documentation.title': 'Documentation',
    'downloadPage.documentation.subtitle': 'Guides and reference for the WEAVR platform',
    'downloadPage.documentation.landing.title': 'Documentation',
    'downloadPage.documentation.landing.description': 'Browse the full WEAVR documentation portal',
    'downloadPage.documentation.creator.title': 'Creator',
    'downloadPage.documentation.creator.description': 'Author procedural XR content with the WYSIWYG editor',
    'downloadPage.documentation.manager.title': 'Manager',
    'downloadPage.documentation.manager.description': 'Manage users, groups, assignments and analytics',
    'downloadPage.documentation.player.title': 'Player',
    'downloadPage.documentation.player.description': 'Run procedures across desktop, mobile and VR',

    'downloadPage.table.header.groupName': 'Type',
    'downloadPage.table.header.name': 'Name',
    'downloadPage.table.header.description': 'Description',
    'downloadPage.table.header.version': 'Version',
    'downloadPage.table.header.releaseNotes': 'Release Notes',
    'downloadPage.table.header.date': 'Date',


    'downloadPage.subRow.description': 'Description',
    'downloadPage.subRow.releaseNotes': 'Release Notes',
    'downloadPage.subRow.olderVersions': 'Previous Versions',
    'downloadPage.table.header.platform': 'Platform',
    'downloadPage.download': 'Download',

    'downloadPage.card.latest': 'Latest',
    'downloadPage.card.versionsCount': (count: number) => `${count} ${count === 1 ? 'version' : 'versions'}`,
    'downloadPage.card.noFile': 'No file',
}
